var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingInfrastructure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Building, Infrastructure / Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.866 18.3334L2.48447 18.3334",
    stroke: "#083342",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.48447 9.16664L9.95282 3.74937C10.9598 3.01893 12.3907 3.01893 13.3977 3.74937L20.866 9.16664",
    stroke: "#083342",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.892 4.58333V2.91667C14.892 2.68655 15.0978 2.5 15.3516 2.5H17.6493C17.9031 2.5 18.1088 2.68655 18.1088 2.91667V7.08333",
    stroke: "#083342",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.32262 18.3333V7.91663",
    stroke: "#083342",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.0279 18.3333V7.91663",
    stroke: "#083342",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.4325 18.3333V14.1666C14.4325 12.9881 14.4325 12.3989 14.0287 12.0327C13.6249 11.6666 12.975 11.6666 11.6752 11.6666C10.3755 11.6666 9.72559 11.6666 9.3218 12.0327C8.91801 12.3989 8.91801 12.9881 8.91801 14.1666V18.3333",
    stroke: "#083342",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.5134 7.91667C13.5134 8.83714 12.6904 9.58333 11.6753 9.58333C10.6601 9.58333 9.8371 8.83714 9.8371 7.91667C9.8371 6.99619 10.6601 6.25 11.6753 6.25C12.6904 6.25 13.5134 6.99619 13.5134 7.91667Z",
    stroke: "#083342",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingInfrastructure);
export default __webpack_public_path__ + "static/media/building-infrastructure.f185e0b736fbe6dd2e65663965cc8c87.svg";
export { ForwardRef as ReactComponent };